module.exports = __webpack_public_path__ + "static/media/huakuai.f4e22ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/huakuai.png
// module id = 234
// module chunks = 0 1